import Api from '../api/api.js';


export default class TagManager {
	

	constructor(params = {}) 
	{
		const defaults = {
			tags:         new Array(),
			upload_url:   '#',
			delete_url:   '#',
			create_form:  '#create-tag-form',
			search_form:  '#search-tags-form'
		};

		this.settings = {...defaults, ...params};
	}


	init()
	{
		this.cacheDom();

		this.bindEvents();
		
		this.initTypeahead();
	}


	cacheDom()
	{
		this.$create_form  = $(this.settings.create_form);

		this.$search_form  = $(this.settings.search_form);
	}


	bindEvents()
	{
		this.$create_form.on('submit', this.onCreateTag.bind(this));

		this.$search_form.on('submit', this.onSearchTag.bind(this));
	}


	getTags()
	{
		return 
	}


	initTypeahead() 
	{
		this.$search_form.find('input').typeahead({

			source: this.settings.tags,
		
			autoSelect: true
		
		});
	}


	onCreateTag(e)
	{
    	e.preventDefault();
    	
    	var data = $(e.target).serializeObject();

    	this.saveTag.call(this, data);
    }


 	onSearchTag(e)
 	{
    	e.preventDefault();

    	var data = this.$search_form.find('input').data('active');

    	this.saveTag.call(this, data);
    }


	saveTag(data)
	{
    	(new Api).postRequest(this.settings.upload_url, data).then(() => {

    		window.location.reload();
    	
    	});
 	}

}